import { AppealHistoryDisplayEntry } from "../utils/formatAppealHistoryEvent";

interface AppealHistoryTimelineItemProps {
  entry: AppealHistoryDisplayEntry;
  isLast: boolean;
}

/**
 * Renders one row in the appeal history vertical timeline.
 *
 * @param props - Timeline entry and whether it is the last item
 * @returns Timeline row element
 */
const AppealHistoryTimelineItem = (props: AppealHistoryTimelineItemProps) => {
  const { entry, isLast } = props;

  return (
    <div className="flex gap-3.5">
      <div className="relative flex w-3 shrink-0 self-stretch justify-start">
        {!isLast ? (
          <div
            className="absolute bottom-0 left-1/2 top-[0.3125rem] w-px -translate-x-1/2 border-l border-dashed border-primaryGray-14"
            aria-hidden
          />
        ) : null}
        <span className="relative z-[1] h-3 w-3 shrink-0 rounded-full border-2 border-black bg-white" />
      </div>

      <div className={`min-w-0 flex-1 ${isLast ? "pb-0" : "pb-6"}`}>
        <div className="mb-1.5 flex items-start justify-between gap-4">
          <span className="text-xs leading-5 text-primaryGray-6">
            {entry.timeLabel}
            <span className="mx-1.5">|</span>
            Date: {entry.dateLabel}
          </span>
          {/* <span className="text-right text-sm font-semibold leading-5 text-primaryGray-1">
            {entry.actorName}
          </span> */}
        </div>

        <div className="m-0 text-sm leading-[1.375rem] text-primaryGray-1">
          {entry.actionSegments.map((segment, index) =>
            segment.bold ? (
              <strong key={`${segment.text}-${index}`} className="font-bold">
                {segment.text}
              </strong>
            ) : (
              <span key={`${segment.text}-${index}`}>{segment.text}</span>
            ),
          )}
        </div>

        {entry.detailNote ? (
          <div className="mt-2.5 whitespace-pre-wrap rounded-md border border-primaryGray-14 bg-primaryGray-16 p-3 text-[0.8125rem] text-primaryGray-3">
            {entry.detailNote}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AppealHistoryTimelineItem;
